import { ESRI, GOOGLE } from '@rsos/constants/mapProviders';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getGlobalRSOS = (): any => (window as any).__RSOS;

/**
 * Returns the center point of the current map view.
 * Works with both ESRI and Google map providers.
 */
const useCenterPointCurrentView = () => {
  const map = getGlobalRSOS()?.map;
  const mapProvider = map?.mapProvider;
  const mapInstance = map?.mapInstance;

  let latitude: number | undefined;
  let longitude: number | undefined;

  if (!mapInstance) {
    return { latitude, longitude };
  }

  if (mapProvider === ESRI) {
    latitude = mapInstance?.view?.center?.latitude;
    longitude = mapInstance?.view?.center?.longitude;
  } else if (mapProvider === GOOGLE) {
    const center = mapInstance?.getCenter?.();
    latitude = center?.lat();
    longitude = center?.lng();
  }

  return { latitude, longitude };
};

export default useCenterPointCurrentView;
